/**
 * パンくずリスト.
 * (C)2024 Chubu Electric Power Grid Co.,Inc. All Rights Reserved.
 * version 1.00 NEC 2024/12/31 初版
 */
import * as React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import {useFunctionQuery} from '../atoms/withMediaQuery.js';
import CommonTheme from '../../Theme.js';
import {Link} from '@mui/material';
const palette = CommonTheme.chubuPalette.primary;

/**
 * パンくずリスト
 * @param {array} items パンくずリストに表示する文字列
 * @param {func} move 遷移関数
 * @return {*} パンくずリスト
 */
export default function CustomBreadcrumbs({items, move}) {
  const isMobile = useFunctionQuery();
  if (isMobile) {
    return <></>;
  }
  if (!items) {
    return <></>;
  }
  const count = items.length - 1;
  const _breadcrumbs = [];
  _breadcrumbs.push(<Typography key="keyBreadcrumbs" color="inherit"></Typography>);
  for (const _item of items) {
    const index = items.indexOf(_item);
    if (index != count) {
      if (move) {
        _breadcrumbs.push(<Link underline="always" key={'keyBreadcrumbs' + index} color="inherit" href="#" onClick={() => move(_item.href)}>{_item.gmnName}</Link>);
      } else {
        _breadcrumbs.push(<Link underline="always" key={'keyBreadcrumbs' + index} color="inherit" href={_item.href}>{_item.gmnName}</Link>);
      }
    }
    if (index == count) {
      _breadcrumbs.push(<Typography key={'keyBreadcrumbs' + index} color={palette.dark}>{_item.gmnName}</Typography>);
    }
  }
  return (
    <div style={{margin: '10px 0px 10px -10px'}}>
      <Breadcrumbs key="keyCustomBreadcrumbs" aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
        {_breadcrumbs}
      </Breadcrumbs>
    </div>
  );
}

CustomBreadcrumbs.propTypes = {
  items: PropTypes.array,
  move: PropTypes.func,
};

